module.exports = __webpack_public_path__ + "static/fig-01-6e9fe44df05e0ad8a1b0baef6fefbff8.png";